// extracted by mini-css-extract-plugin
export default {"loginTypeTabs":"loginTypeTabs_bQ7Dk","tabItem":"tabItem_HJMcL","active":"active_GwyGC"};